/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1TransportData } from '../../entities/v1/TransportData'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1TransportDataSchema = z.object({
  brand: z.string().optional(),
  brand_id: z.number().int().optional(),
  color: z.string().optional(),
  color_id: z.string().optional(),
  model: z.string().optional(),
  model_id: z.number().int().optional(),
}) as unknown as ToZod<V1TransportData>